import { render, staticRenderFns } from "./aportesServicios.vue?vue&type=template&id=5fc14822&"
import script from "./aportesServicios.vue?vue&type=script&lang=js&"
export * from "./aportesServicios.vue?vue&type=script&lang=js&"
import style0 from "./aportesServicios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports